module.exports = __webpack_public_path__ + "img/secondary-button-sample.f7a95cfb.svg";